// @flow
// $FlowFixMe
import React, {Component, type Node, Suspense} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Experiment from '@homeaway/react-experiment';
import GoogleOneTapLogin from '@homeaway/ha-google-one-tap';
import SiteHeader from '@homeaway/react-site-header';
import TransitionBanner from '@homeaway/react-brand-transition-banner';
import {TripBoardCoachMark} from '@homeaway/react-trip-board-button';
import {
    TripBoardLink
    // $FlowFixMe
} from '../TripBoardButton/TripBoardLink';
import breakpoints from '../../utils/breakpoints';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';

import {
    HA_IDA_SERP_GOOGLEONETAP,
    HA_IDA_SERP_HEADER_LOGIN_TEST,
    HA_IDA_V3_LOGIN_TEST,
    HA_GX_PRE_BRAND_TRANSITION,
    HA_GX_POST_BRAND_TRANSITION,
    HA_PULSE_COACHMARK_VIEW_BOARD
} from '../../abacus/experiments';

import type {State as ReduxState} from '../../reducers/index';

const LINGUA_KEYS = {
    preTitle: 'pre.transition.title',
    preInfo: 'pre.transition.info',
    postTitle: 'post.transition.title',
    postInfo: 'post.transition.info'
};

// $FlowFixMe
const LoginExperience = React.lazy(
    /* istanbul ignore next */ () =>
        import(/* webpackChunkName: "react-lex" */ '@homeaway/react-lex')
);

type StateProps = {
    siteName: string,
    theme: string,
    isMobile: boolean,
    fullLocale: string,
    currency: string,
    brand: string,
    headerData: {}
};

type OwnProps = {
    internalTools?: Node,
    showBrandTransitionBanner: string,
    feedbackComponentLingua: {}
};

type Props = OwnProps & StateProps & LinguaProps;

type State = {
    googleCredentialsReported: boolean,
    displayNotificationJewel: boolean,
    displayGoogleFrame: boolean,
    loginModalOpen: boolean,
    isUserLogged: boolean
};

type scratchpadLinkType = {
    scratchapdLink: Node
};

export class HeaderBar extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            googleCredentialsReported: false,
            displayNotificationJewel: false,
            displayGoogleFrame: false,
            loginModalOpen: false,
            isUserLogged:
                props.headerData.hasOwnProperty('traveler') ||
                props.headerData.hasOwnProperty('owner')
        };
    }

    handleShowModal = () => {
        this.setState({loginModalOpen: true});
    };

    handleCloseModal = () => {
        this.setState({loginModalOpen: false});
    };

    handleLoginSuccess = (options: Object) => {
        if (options && options.publicUuid) {
            window.analyticsdatalayer.publicuuid = options.publicUuid;
        }
        this.setState({isUserLogged: true});
    };

    handleTrayChange = (opened: boolean) => {
        if (opened) {
            this.setState({
                displayGoogleFrame: true
            });
        } else {
            this.setState({
                displayGoogleFrame: false,
                displayNotificationJewel: false
            });
        }
    };

    handleGoogleCredentialsAvailable = () => {
        if (this.state.googleCredentialsReported) {
            return;
        }
        this.setState({
            displayNotificationJewel: true,
            googleCredentialsReported: true
        });
    };

    handleGetTripBoard = ({
        scratchpadLink
    }: {
        scratchpadLink: scratchpadLinkType
    }) => {
        if (!this.props.isMobile) {
            return (
                <Experiment name={HA_PULSE_COACHMARK_VIEW_BOARD}>
                    {({On, Off}) => (
                        <React.Fragment>
                            <On>
                                <TripBoardCoachMark
                                    scratchpadLink={scratchpadLink}
                                />
                            </On>
                            <Off>
                                <TripBoardLink
                                    scratchpadLink={scratchpadLink}
                                />
                            </Off>
                        </React.Fragment>
                    )}
                </Experiment>
            );
        }
        return null;
    };

    render() {
        let {
            siteName,
            theme,
            isMobile,
            internalTools,
            fullLocale,
            currency,
            brand,
            showBrandTransitionBanner,
            headerData,
            messages,
            feedbackComponentLingua
        } = this.props;

        const {
            displayGoogleFrame,
            displayNotificationJewel,
            isUserLogged,
            loginModalOpen
        } = this.state;

        const loginProps = {
            modalMode: true,
            locale: fullLocale,
            site: siteName,
            siteName: brand,
            handleCloseModal: this.handleCloseModal,
            handleLoginSuccess: this.handleLoginSuccess
        };

        const siteHeaderProps = {
            dataUrl: '/serp/api/header',
            siteName,
            theme,
            isMobile,
            data: headerData,
            displayTrayJewel: displayNotificationJewel,
            fetchUserData: isUserLogged,
            fullLocale,
            onTrayChange: this.handleTrayChange,
            internalTools,
            currencyCode: currency,
            mobileBreakpoint: breakpoints.MD_MIN - 1,
            tripboard: this.handleGetTripBoard,
            withoutCountryLanguageSelector: true,
            withoutCurrencySelector: false,
            withoutLocaleSwitcher: false,
            feedbackComponentLingua
        };

        const preTitle = messages[LINGUA_KEYS.preTitle];
        const preInfo = messages[LINGUA_KEYS.preInfo];
        const postTitle = messages[LINGUA_KEYS.postTitle];
        const postInfo = messages[LINGUA_KEYS.postInfo];

        return (
            <div className="HeaderBar" role="group">
                <Experiment name={HA_IDA_SERP_HEADER_LOGIN_TEST}>
                    {({On, Off}) => (
                        <React.Fragment>
                            <On>
                                <SiteHeader
                                    {...siteHeaderProps}
                                    travelerLoginClickHandler={
                                        this.handleShowModal
                                    }
                                />
                            </On>
                            <Off>
                                <SiteHeader {...siteHeaderProps} />
                            </Off>
                        </React.Fragment>
                    )}
                </Experiment>

                <Experiment name={HA_GX_PRE_BRAND_TRANSITION} variant={1}>
                    <TransitionBanner
                        forPreTransition
                        title={preTitle}
                        info={preInfo}
                    />
                </Experiment>
                {showBrandTransitionBanner && (
                    <Experiment name={HA_GX_POST_BRAND_TRANSITION} variant={1}>
                        <TransitionBanner
                            forPreTransition={false}
                            title={postTitle}
                            info={postInfo}
                        />
                    </Experiment>
                )}
                {loginModalOpen && (
                    <Experiment name={HA_IDA_V3_LOGIN_TEST}>
                        {({On, Off}) => (
                            <Suspense fallback={null}>
                                <On>
                                    <LoginExperience
                                        useNewEndpoints
                                        {...loginProps}
                                    />
                                </On>
                                <Off>
                                    <LoginExperience {...loginProps} />
                                </Off>
                            </Suspense>
                        )}
                    </Experiment>
                )}
                {!isUserLogged && (
                    <Experiment name={HA_IDA_SERP_GOOGLEONETAP} variant={1}>
                        <GoogleOneTapLogin
                            displayIFrame={displayGoogleFrame}
                            onCredentialsAvailable={
                                this.handleGoogleCredentialsAvailable
                            }
                            focus
                            closeOnFocusOut
                            loginSuccessCallback={this.handleLoginSuccess}
                        />
                    </Experiment>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({
    system: {siteName, theme, isMobile, fullLocale, currency, brand},
    header
}: ReduxState): StateProps => ({
    siteName,
    theme,
    isMobile,
    fullLocale,
    currency,
    brand,
    headerData: header
});

export default compose(
    connect(mapStateToProps),
    withLingua({
        namespace: 'gx/globalization',
        category: 'rebrandingBrandTransition'
    })
)(HeaderBar);
